// extracted by mini-css-extract-plugin
export default {"-large":"gvyG7RDmdbyNMc89kKRn","layoutStyles":"BQwWnvG9_li9QdBVPecP","mobileContainer":"ebiDqOZSkXVgpIwGESv1","mobileStyles":"Xtm4d9ZeUxtv5imsuEfK"};